var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7914 9.99935C7.7914 9.90213 7.80528 9.80852 7.83306 9.71852C7.86084 9.62796 7.9164 9.54796 7.99973 9.47852L11.7497 5.70768C11.8747 5.59657 12.0206 5.54102 12.1872 5.54102C12.3539 5.54102 12.4997 5.60352 12.6247 5.72852C12.7358 5.85352 12.7914 5.99935 12.7914 6.16602C12.7914 6.33268 12.7358 6.47852 12.6247 6.60352L9.22889 9.99935L12.6247 13.416C12.7497 13.5271 12.8089 13.666 12.8022 13.8327C12.795 13.9993 12.7358 14.1452 12.6247 14.2702C12.4997 14.3952 12.3506 14.4577 12.1772 14.4577C12.0033 14.4577 11.8608 14.3952 11.7497 14.2702L7.99973 10.5202C7.9164 10.4507 7.86084 10.371 7.83306 10.281C7.80528 10.1905 7.7914 10.0966 7.7914 9.99935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWhite);
export default __webpack_public_path__ + "static/media/chevron-white.8d4f59152a59e0c4d9c9ec8299bc1de8.svg";
export { ForwardRef as ReactComponent };